import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Toolbar = styled.nav`
  display: flex;
  align-items: center;
  padding: 13px 30px 13px 50px;
  background-color: #fafafa;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #e9e9e9;
  gap: 10px;
`

export const SearchBox = styled.div`
  cursor: text;
  white-space: nowrap;
  display: flex;
  align-items: center;
  min-width: 200px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
`

export const InputContainer = styled.div`
  position: relative;
  cursor: text;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  display: flex;
  gap: 5px;
  align-items: center;
`

export const input = css`
  color: black;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 12px;
  background: transparent;
`

export const icon = css`
  color: #777;
`
